import React, { useEffect } from "react";
import { ConfirmationModalProps } from "../../../types";
import Button from "../Button/Button";
import "./ConfirmationModal.css";

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmVariant = "primary",
  onConfirm,
  onCancel,
  isLoading = false,
}) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape" && isOpen && !isLoading) {
        onCancel();
      }
    };

    if (isOpen) {
      document.body.style.overflow = "hidden";
      window.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, isLoading, onCancel]);

  if (!isOpen) return null;

  return (
    <div
      className="confirmation-modal-overlay"
      onClick={onCancel}
      aria-modal="true"
      role="dialog"
      aria-labelledby="confirmation-modal-title"
    >
      <div
        className="confirmation-modal-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="confirmation-modal-header">
          <h3 id="confirmation-modal-title" className="confirmation-modal-title">
            {title}
          </h3>
          <button
            type="button"
            className="confirmation-modal-close-btn"
            onClick={onCancel}
            disabled={isLoading}
            aria-label="Close modal"
          >
            &times;
          </button>
        </div>

        <div className="confirmation-modal-body">
          {message}
        </div>

        <div className="confirmation-modal-footer">
          <Button
            type="button"
            variant="outline"
            size="medium"
            onClick={onCancel}
            disabled={isLoading}
          >
            {cancelText}
          </Button>
          <Button
            type="button"
            variant={confirmVariant}
            size="medium"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? "Processing..." : confirmText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
